import { create } from 'zustand'

interface MissionStatusStore {
  missionStatus: Record<string, any> | null
  setMissionStatus: (data: Record<string, any>) => void
  clearMissionStatus: () => void
}

const useMissionStatusStore = create<MissionStatusStore>((set) => ({
  missionStatus: null,
  setMissionStatus: (data) => set({ missionStatus: data }),
  clearMissionStatus: () => set({ missionStatus: null }),
}))

export default useMissionStatusStore